module.exports = __webpack_public_path__ + "img/rose_apple.fdff9237.png";